import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  CircularProgress,
  Grid,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import Header from "../../components/Header";
import { tokens } from "../../theme";

function ViewUserById() {
  const { id } = useParams();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchUserDetails();
  }, [id]);

  const fetchUserDetails = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://backend.placemyfilms.com/user/getUserById/${id}`
      );
      const responseData = await response.json();

      if (responseData.status && responseData.result && responseData.result.length > 0) {
        setUserDetails(responseData.result[0]); // Access the first item in the result array
      } else {
        setError(`Failed to fetch user details: ${responseData.message}`);
      }
    } catch (err) {
      setError(`Error fetching user details: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const formatFieldName = (field) => {
    return field.replace(/([A-Z])/g, " $1").trim();
  };

  // Format date fields for better display
  const formatValue = (field, value) => {
    if (field.toLowerCase().includes('at') && value) {
      return new Date(value).toLocaleString();
    }
    if (field === 'password') {
      return '********'; // Hide password
    }
    return value !== null && value !== "" ? value : "Not Available";
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box m="20px">
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  if (!userDetails) {
    return (
      <Box m="20px">
        <Typography variant="h6">No user details found.</Typography>
      </Box>
    );
  }

  return (
    <Box m="20px" height="70vh" overflow="auto" paddingRight="20px">
      <Header title="View User Details" subtitle={`User ID: ${id}`} />
      <Box ml={"40px"}>
        <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
          <Typography
            variant="h6"
            fontWeight="bold"
            mb={2}
            color={colors.blueAccent[400]}
          >
            User Details
          </Typography>
          <Grid container spacing={2}>
            {Object.entries(userDetails).map(([field, value]) => (
              <Grid item xs={12} key={field}>
                <Grid container>
                  <Grid item xs={3}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {formatFieldName(field)}:
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Typography>
                      {formatValue(field, value)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Box>
    </Box>
  );
}

export default ViewUserById;